import { Location } from '@angular/common';
import { Component, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Register } from '@klickdata/core/auth/src/auth/register.model';
import { AuthService } from '@klickdata/core/auth/src/token/auth.service';
import { ErrorResponse } from '@klickdata/core/http/src/responce/error-responce';
import { Observable, of, Subscription } from 'rxjs';

@Component({
    selector: 'app-guest-trial',
    templateUrl: 'trial.component.html',
    styleUrls: ['trial.component.css'],
})
export class TrialComponent implements OnDestroy {
    register: Register;
    subscription: Subscription;
    error: Observable<{ messages: string[] }>;

    constructor(protected auth: AuthService, protected route: Router, protected location: Location) {
        this.register = new Register();
    }

    onSubmit() {
        this.subscription = this.auth.register(this.register).subscribe(
            () => {
                this.route.navigate(['/home']);
            },
            err => (this.error = of(err.error))
        );
    }

    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }

    public goBack(): void {
        this.location.back();
    }
}
